export default __webpack_public_path__ + "static/media/chat.cd24a983.svg";